const rteTablesInit = () => {
  // Add wrapping div to tables in RTE
  const rteTables = document.querySelectorAll('.rte table');
  if (rteTables.length === 0) return;

  rteTables.forEach((item) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte__table-wrapper');
    item.parentNode.insertBefore(wrapper, item);
    wrapper.appendChild(item);
  });
};

export default rteTablesInit;
